import {items} from '../../collectionsData';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';

const ItemDetails = () => {
    let item = items[5];
    
    return(
        <div className="bg-[white] dark:bg-dark-content-bg dark:text-white transition-colors duration-300 ease-in-out">
            <div className="max-w-[1600px] mx-auto px-[5vw] lg:px-5 xl:px-10 py-10">

                <div className="md:flex">

                    <div className='md:w-[40%] flex flex-col'>
                        <div className=" h-fit mb-8">
                            <img src = {item.image} 
                                alt = 'item' className = 'w-full h-full object-contain shadow-shadow3 rounded-[7px]'/>
                        </div>
                        <p className='hidden md:block text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>
                            SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.
                        </p>
                    </div>

                    <div className="flex flex-col md:w-[55%] ml-auto pt-8">
                        <h2 className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-slate-600 dark:text-gray-400 mb-3'>{item.collection}</h2>
                        <h1 className='mb-3 leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                            {item.name}
                        </h1>
                        <h2 className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-slate-600 dark:text-gray-400 mb-7'>Owned By: <span className='text-main font-[500]'>{item.owner}</span></h2>

                        <div className='flex border-b-gray-400 md:border-b-[1px] mb-8 md:pb-8'>
                            <PrimaryButton title = 'Make SQL Offer' className = "mr-4"/>
                            <PrimaryButton title = 'Make NFT Offer' />
                        </div>

                        <p className='md:hidden text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400 border-b-[1px] border-b-[gray] pb-8 mb-4'>
                            SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.
                        </p>

                        <div className='grid sm:grid-cols-2 2xl:grid-cols-3 gap-4 mb-8'>

                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-[1px] rounded-[7px]'>
                                <div className='flex flex-col mr-3'>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>Attribute Counts</p>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>3</p>
                                </div>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-black dark:text-white font-bold'>29.8%</p>
                            </div>

                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-[1px] rounded-[7px]'>
                                <div className='flex flex-col mr-3'>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>Attribute Counts</p>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>3</p>
                                </div>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-black dark:text-white font-bold'>29.8%</p>
                            </div>

                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-[1px] rounded-[7px]'>
                                <div className='flex flex-col mr-3'>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>Attribute Counts</p>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>3</p>
                                </div>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-black dark:text-white font-bold'>29.8%</p>
                            </div>

                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-[1px] rounded-[7px]'>
                                <div className='flex flex-col mr-3'>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>Attribute Counts</p>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>3</p>
                                </div>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-black dark:text-white font-bold'>29.8%</p>
                            </div>

                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-[1px] rounded-[7px]'>
                                <div className='flex flex-col mr-3'>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>Attribute Counts</p>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>3</p>
                                </div>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-black dark:text-white font-bold'>29.8%</p>
                            </div>

                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-[1px] rounded-[7px]'>
                                <div className='flex flex-col mr-3'>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>Attribute Counts</p>
                                    <p className='text-sm lg:text-base 2xl:text-lg text-slate-600 dark:text-gray-400'>3</p>
                                </div>
                                <p className='text-sm sm:text-base lg:text-lg 2xl:text-xl text-black dark:text-white font-bold'>29.8%</p>
                            </div>

                        </div>

                        <div className='border-[1px] rounded-[7px] border-gray-300 dark:border-gray-700'>
                            <div className='flex items-center justify-between px-2 py-2 border-gray-300 dark:border-gray-700 border-b-[1px]'>
                                <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-bold'>Offers</p>
                                <button className='text-sm 2xl:text-base text-black dark:text-white'>See All</button>
                            </div>

                            <div className='grid grid-cols-3 gap-4 py-3 border-gray-300 dark:border-gray-700 border-b-[1px]'>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>Price</p>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>Expiration</p>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>Offers</p>
                            </div>

                            <div className='grid grid-cols-3 gap-4 py-2 border-gray-300 dark:border-gray-700 border-b-[1px]'>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>21.8</p>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>2m 4d</p>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>dx234244</p>
                            </div>

                            <div className='grid grid-cols-3 gap-4 py-2 '>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>21.8</p>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white'>2m 4d</p>
                                <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>dx234244</p>
                            </div>

                        </div>

               
                    </div>

                </div>

                <div className='border-[1px] rounded-[7px] border-gray-300 dark:border-gray-700 mt-10 overflow-auto main-scrollbar'>

                    <div className='w-[50rem] md:w-full'>
                        <div className='flex items-center justify-between px-5 py-5 border-gray-400 dark:border-gray-700 border-b-[1px]'>
                            <p className='text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-bold'>Trading History</p>
                            <div className='flex'>
                                <button className='text-sm mr-3 2xl:text-base text-black dark:text-white'>Listing</button>
                                <button className='text-sm mr-3 2xl:text-base text-black dark:text-white'>Sale</button>
                                <button className='text-sm mr-3 2xl:text-base text-black dark:text-white'>Offer</button>
                                <button className='text-sm 2xl:text-base text-black dark:text-white'>See All</button>
                            </div>
                        </div>

                        <table className='w-full'>
                            <thead className='border-gray-400 dark:border-gray-700 border-b-[1px]'>
                                <tr >
                                    <th>
                                        <p className='p-4 text-center w-full text-sm lg:text-base 2xl:text-lg  text-gray-400 font-[500]'>Event</p>
                                    </th>
                                    <th>
                                        <p className='text-center w-full text-sm lg:text-base 2xl:text-lg  text-gray-400 font-[500]'>Item</p>
                                    </th>
                                    <th>
                                        <p className='text-center w-full text-sm lg:text-base 2xl:text-lg  text-gray-400 font-[500]'>Price</p>
                                    </th>
                                    <th>
                                        <p className='text-center w-full text-sm lg:text-base 2xl:text-lg  text-gray-400 font-[500]'>From</p>
                                    </th>
                                    <th>
                                        <p className='text-center w-full text-sm lg:text-base 2xl:text-lg  text-gray-400 font-[500]'>To</p>
                                    </th>
                                    <th>
                                        <p className='text-center w-full text-sm lg:text-base 2xl:text-lg  text-gray-400 font-[500]'>Date</p>
                                    </th>
                                </tr>
                            </thead>

                        <tbody>
                            <tr className='border-gray-400 dark:border-gray-700 border-b-[1px]'>
                                <td>
                                    <p className='p-4 text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white '>Offer</p>
                                </td>
                                <td>    
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>SMB#2770</p>
                                </td>
                                <td>
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white '>10.7</p>
                                </td>
                                <td>
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-main font-[500]'>FX0CWx13S</p>
                                </td>
                                <td>    
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-main font-[500]'>GsB24Dsx1</p>
                                </td>
                                <td>    
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white '>1 month ago</p>
                                </td>
                            </tr>
                            <tr className='border-gray-400 dark:border-gray-700 border-b-[1px]'>
                                <td>
                                    <p className='p-4 text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white '>Offer</p>
                                </td>
                                <td>    
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white font-[500]'>SMB#2770</p>
                                </td>
                                <td>
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white '>10.7</p>
                                </td>
                                <td>
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-main font-[500]'>FX0CWx13S</p>
                                </td>
                                <td>    
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-main font-[500]'>GsB24Dsx1</p>
                                </td>
                                <td>    
                                    <p className='text-center w-full text-sm lg:text-base 2xl:text-lg text-black dark:text-white '>1 month ago</p>
                                </td>
                            </tr>

                        </tbody>
                        
                        </table>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default ItemDetails;